import clsx from 'clsx';

const Line = ({ w }: { w: string }) => <div className={clsx('h-3 bg-gray-300 rounded mb-2', w)} />;

const StatRow = () => (
  <div className='flex flex-col p-2 items-center'>
    <Line w='w-36' />
    <Line w='w-10' />
  </div>
);

const StatBlock = ({ count, className = '' }: { count: number; className?: string }) => (
  <div
    className={clsx(
      'rounded-lg flex flex-row items-center animate-pulse px-4 md:px-24 py-4',
      className
    )}
  >
    <div className='w-full h-auto relative flex items-center justify-center px-4 md:px-24 bg-white rounded-lg pt-2'>
      <div className='flex flex-col items-center'>
        {Array.from({ length: count }, () => crypto.randomUUID()).map((id) => (
          <StatRow key={id} />
        ))}
      </div>
    </div>
  </div>
);

const ProgressCardSkeleton = () => (
  <div className='bg-white p-2 rounded-lg shadow-sm border border-gray-100 flex flex-col items-center animate-pulse'>
    <div className='h-4 w-20 bg-gray-200 rounded mb-1' />
    <div className='h-5 w-12 bg-gray-300 rounded mb-3' />
    <div className='relative w-24 h-24 flex items-center justify-center'>
      <div className='w-20 h-20 rounded-full border-8 border-gray-200' />
      <div className='absolute h-4 w-8 bg-gray-300 rounded' />
    </div>
    <div className='h-6 w-10 bg-gray-300 rounded mt-3' />
  </div>
);

export function CurrentSeedSkeleton() {
  return (
    <div className='max-w-7xl mx-auto'>
      <div className='bg-brand-50 rounded-lg shadow-sm border border-gray-200'>
        <StatBlock count={4} className='mt-16' />

        <div className='grid grid-cols-1 gap-4 mt-4 px-4 md:px-24 py-2'>
          {Array.from({ length: 2 }, () => crypto.randomUUID()).map((id) => (
            <ProgressCardSkeleton key={id} />
          ))}
        </div>

        <StatBlock count={6} />
      </div>
    </div>
  );
}
